import { formattedDate, numberFormatter } from '../Helpers';
import { services } from './DummyData';
import {
  ContactIcon,
  RefreshIcon,
  CalendarIcon,
  SendNextIcon,
  DivideIcon,
  HistoryIcon,
  WalletIcon,
  EditIconPencil,
  DeleteIcon,
  SethoscopeIcon,
  CurrencyIcon,
  TrashIcon,
  MedicineIcon,
  QueueIcon,
  CreditCardIcon
} from '../Assets/icons';

import { jazzCash, EasyPesa, JazzCash } from '../Constant';

const gender = [
  { label: 'Male', value: 'male' },
  {
    label: 'Female',
    value: 'female'
  },
  { label: 'Rather not say', value: 'other' }
];

const patientTableItem = [
  {
    id: '1',
    title: 'Cell Number',
    key: 'cellNumber',
    type: 'number',
    textAlign: 'right'
  },
  { id: '2', title: 'Patient(s) Name', key: 'name', textAlign: 'left' },

  {
    id: '3',
    title: 'Age/Gender',
    key: 'age',
    key2: 'gender',
    type: 'string',
    textAlign: 'right'
  },

  {
    id: '5',
    title: 'Last Visit',
    key: 'lastVisit',
    type: 'date',
    textAlign: 'right',
    changeValue(value) {
      formattedDate(value);
    }
  },

  {
    id: '6',
    title: 'Upcoming Visit',
    key: 'upcomingAppointment',
    type: 'date',
    textAlign: 'right',
    changeValue(value) {
      formattedDate(value);
    }
  },
  {
    id: '5',
    title: 'Total (Rs.)',
    key: 'totalNetAmount',
    type: 'number',

    textAlign: 'right'
  }
];

const todayAppointmentFields = [
  {
    id: '1',
    title: 'Patient Name',
    key: 'name',
    type: 'string',
    textAlign: 'right'
  },

  {
    id: '3',
    title: 'Appointment',
    key: 'appointment',

    type: 'string',
    textAlign: 'right'
  }
];

const currentSessionTableField = [
  { id: '1', title: 'Token No', key: 'tokenNumber', textAlign: 'left' },
  { id: 2, title: 'Age/Gender', key: 'age', key: 'gender', textAlign: 'center' },
  { id: '3', title: 'Cell Number', key: 'cellNumber', textAlign: 'center' },
  { id: '4', title: 'Patient Type', key: 'patientType', textAlign: 'center' },
  {
    id: 5,
    title: 'Fees(Rs).',
    key: 'fees',
    textAlign: 'right'
  },

  {
    id: 5,
    title: 'Service(s)',
    key: 'services',
    textAlign: 'left'
  }
];

const todayAppointmentAction = [
  // { id: 1, icon: <ContactIcon />, label: 'Contact' },
  { id: 2, icon: <RefreshIcon />, label: 'Reschedule' },
  { id: 3, icon: <CalendarIcon />, label: 'Cancel Appointment' }
];

const currentSessionAction = [
  { id: 1, icon: <SendNextIcon />, label: 'Send Patient' },
  { id: 2, icon: <EditIconPencil />, label: 'Edit Patient' },
  { id: 3, icon: <TrashIcon />, label: 'Delete Patient' }
];
const currentHistoryAction = [
  { id: 1, icon: <CurrencyIcon />, label: 'Diagnosis' },
  { id: 2, icon: <MedicineIcon />, label: 'Prescribe' },
  { id: 3, icon: <CalendarIcon />, label: 'Follow Up' },
  { id: 4, icon: <HistoryIcon />, label: 'Previous History' },
  { id: 5, icon: <SethoscopeIcon />, label: 'Services' },
  { id: 6, icon: <CurrencyIcon />, label: 'Payments' }
];

const diagnosisAction = [
  { id: 1, icon: <MedicineIcon />, label: 'Prescribe' },
  { id: 2, icon: <CalendarIcon />, label: 'Follow Up' },
  { id: 3, icon: <HistoryIcon />, label: 'Previous History' },
  { id: 4, icon: <SethoscopeIcon />, label: 'Services' },
  { id: 5, icon: <CurrencyIcon />, label: 'Payments' }
];

const medicineDuration = [
  { label: 'Day(s)', value: 'day' },
  { label: 'Week(s)', value: 'week' },
  { label: 'Month(s)', value: 'month' }
];

const medicineFrequency = [
  { label: 'Morning', value: 'morning' },
  { label: 'Evening', value: 'evening' },
  { label: 'SOS', value: 'sos' }
];

const quickActions = [
  { id: '1', title: 'Add to queue', icon: <QueueIcon color="var(--icon-color)" /> },
  // { id: '2', title: 'Contact', icon: <ContactIcon /> },
  { id: '3', title: 'Reschedule', icon: <RefreshIcon /> },
  { id: '4', title: 'Cancel', icon: <CalendarIcon /> }
];

const weeksDay = [
  { id: 1, label: 'S', value: 'Sun' },
  { id: 2, label: 'M', value: 'Mon' },
  { id: 3, label: 'T', value: 'Tue' },
  { id: 4, label: 'W', value: 'Wed' },
  { id: 5, label: 'T', value: 'Thu' },
  { id: 6, label: 'F', value: 'Fri' },
  { id: 6, label: 'S', value: 'Sat' }
];

const paymentsOptions = [
  { id: '1', title: 'Cash', icon: <CurrencyIcon size={20} color="var(--primary-color)" /> },
  { id: '2', title: 'Credit/Debit Card', icon: <CreditCardIcon /> },

  { id: '3', title: 'Easypaisa ', icon: <EasyPesa size={20} /> },
  { id: '4', title: 'Jazz Cash', icon: <JazzCash size={20} /> }
];

const packageDetails = [
  'Queue management',
  'Patient management',
  'Appointment',
  'Multi-role management',
  'Self patient check-in',
  'Patient medical record',
  'Procedure fee management'
];

const frequencyDefaultTypes = [
  { label: 'Morning', value: 'Morning' },
  {
    label: 'Evening',
    value: 'Evening'
  },
  { label: 'SOS', value: 'SOS' }
];
const medicineDefaultTypes = [
  { label: 'Syrup', value: 'Syrup' },
  { label: 'Tablet', value: 'Tablet' }
];
const dateOptions = [
  { label: 'Year(s)', value: 'Yrs' },
  {
    label: 'Day(s)',
    value: 'Day'
  },
  { label: 'Month(s)', value: 'Mon' }
];
const percentages = [
  { label: '25%', value: 25 },
  { label: '50%', value: 50 },
  { label: '75%', value: 75 },
  { label: '100%', value: 100 }
];
const smsSettingListing = [
  { id: '1', label: 'Creation of Appointment', key: 'smsIsCreationOfAppointment' },
  { id: '2', label: 'Appointment Reminder', key: 'smsIsAppointmentReminder' },
  { id: '3', label: 'Reschedule of Appointment', key: 'smsIsRescheduleOfAppointment' },
  { id: '4', label: 'Cancellation of Appointment', key: 'smsIsCancellationOfAppointment' },
  { id: '5', label: 'Prescription', key: 'smsIsPrescription' },
  { id: '6', label: 'Invoice', key: 'smsIsInvoice' }
];

const timeUnits = [
  { id: '1', label: 'Hour', value: 'H' },
  { id: '2', label: 'Minutes', value: 'M' }
];

const lineGraphData = [
  { id: '1', label: '1 Month', value: '' },
  { id: '2', label: '1 Week', value: '' },
  { id: '3', label: '2 Week', value: '' },
  { id: '4', label: '3 Week', value: '' }
];
const timePeriodOptions = [
  { label: 'Today', value: 'today' },
  { label: 'This Week', value: 'weekly' },
  { label: 'This Month', value: 'monthly' },
  { label: 'This Year', value: 'yearly' }
];

const graphTimePeriodOptions = [
  { label: '1 Month', value: '' },
  { label: '1 Week', value: '' },
  { label: '2 Week', value: '' },
  { label: '3 Week', value: '' }
];

const graphViewOptions = [
  { label: 'Payments', value: 1 },
  { label: 'Waived Amount', value: 2 }
];
const dateRanges = ['Today', 'Weekly', 'Monthly', 'Yearly'];

const patientFlowOptions = [
  { label: 'All', value: 0 },
  {
    label: 'Male',
    value: 1
  },
  { label: 'Female', value: 2 }
];
// [0.1,2,3,4]

const ageGroupOptions = [
  { label: '0-18', value: 0 },
  { label: '18-36', value: 1 },
  { label: '36-54', value: 2 },
  { label: '54+', value: 3 }
];
const patientType = [
  { label: 'Total Patient', value: 1 },
  { label: 'New Patient', value: 2 }
];
export {
  currentSessionTableField,
  patientTableItem,
  gender,
  todayAppointmentFields as todayAppointment,
  todayAppointmentAction,
  currentSessionAction,
  diagnosisAction,
  currentHistoryAction,
  medicineDuration,
  medicineFrequency,
  quickActions,
  weeksDay,
  paymentsOptions,
  packageDetails,
  frequencyDefaultTypes,
  medicineDefaultTypes,
  dateOptions,
  percentages,
  smsSettingListing,
  timeUnits,
  lineGraphData,
  dateRanges,
  timePeriodOptions,
  graphTimePeriodOptions,
  graphViewOptions,
  patientFlowOptions,
  ageGroupOptions,
  patientType
};
